import { render, staticRenderFns } from "./MenuEdit.vue?vue&type=template&id=249260c7&scoped=true"
import script from "./MenuEdit.vue?vue&type=script&lang=js"
export * from "./MenuEdit.vue?vue&type=script&lang=js"
import style0 from "./MenuEdit.vue?vue&type=style&index=0&id=249260c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249260c7",
  null
  
)

export default component.exports